/* unplugin-vue-components disabled */import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-editor.vue?vue&type=style&index=0&id=492be8ec&scoped=true&lang=scss"
import "./message-input-editor.vue?vue&type=style&index=1&id=492be8ec&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492be8ec"]])

export default __exports__